import { Injectable } from '@angular/core';
import { AlloxApiService } from './allox-api.service';
import { PlacementRelation, ResponseTsvData, PlacementRelationSearchParam } from '../models';
import { map } from 'rxjs/operators';

interface IPlacementRelationSearchParameter {
  name?: string;
  media_type?: string;
  placement_id?: string;
  platform_id?: number;
  ad_request_name?: string;
  has_delivery_set?: boolean;
}

@Injectable({ providedIn: 'root' })
export class PlacementRelationService {

  private path = '/placement_relations';

  constructor(private http: AlloxApiService) { }

  public search(param: IPlacementRelationSearchParameter = {}) {
    const query = Object.keys(param)
      .filter(k => param[k] != null)
      .reduce((prev, k) => prev += '&' + k + '=' + encodeURIComponent(param[k]), '')
      .replace('&', '?');
    return this.http.get<[]>(this.path + query).pipe(
      map(objs => objs.map(obj => new PlacementRelation(obj)))
    );
  }

  public fetch(id: number) {
    return this.http.get(this.path + '/' + id).pipe(
      map(obj => new PlacementRelation(obj))
    );
  }

  public post(item: PlacementRelation) {
    const json = item.toJSON();
    return this.http.post(this.path, json);
  }

  public put(item: PlacementRelation) {
    const json = item.toJSON();
    return this.http.put(this.path + '/' + item.id, json);
  }

  public deletes(items: PlacementRelation[]) {
    const dItems = items.map(item => item.toDeleteItemJSON());
    return this.http.post(this.path + '/delete', { delete_items: dItems });
  }

    /**
   * プレースメント設定一括登録
   * @remarks
   * サーバ処理を呼び出してプレースメント設定の登録処理を行う
   * @param item 入力したURL
   * @returns 実行結果
   */
  public batchPost(item: string) {
    return this.http.post(this.path + '/batch', { url: item });
  }

  /**
 * Returns TSV download information
 *
 * @remarks
 * This method communicates the TSV download API and returns the information necessary for download
 *
 * @param param Placement Relation Search Criteria
 * @returns TSV data and file name
 */
  public export(param: PlacementRelationSearchParam) {
    const json = param.toJSON();
    return this.http.post(this.path + '/export', json).pipe(
      map(obj => new ResponseTsvData(obj))
    );
  }

}
